@if (visible && (message || isRawHtml)) {
  <div
    class="banner banner-{{ type }} w-100 d-flex align-items-center justify-content-between gap-2"
    role="alert"
    [attr.data-banner-type]="type"
  >
    <div class="banner-icon-text d-flex align-items-center justify-content-between gap-2">
      @if (!!icon) {
        <ds-icon [icon]="icon" [iconStyle]="iconStyle"></ds-icon>
      } @else {
        @switch (type) {
          @case (BannerType.success) {
            <ds-icon [icon]="Icons.Check" [iconStyle]="iconStyle"></ds-icon>
          }
          @case (BannerType.info) {
            <ds-icon [icon]="Icons.CircleInfo" [iconStyle]="iconStyle"></ds-icon>
          }
          @case (BannerType.error) {
            <ds-icon [icon]="Icons.CircleExclamation" [iconStyle]="iconStyle"></ds-icon>
          }
          @case (BannerType.warning) {
            <ds-icon [icon]="Icons.TriangleExclamation" [iconStyle]="iconStyle"></ds-icon>
          }
        }
      }
      @if (!isRawHtml) {
        <div class="flex-grow-1 text-break">
          @if (isHtml) {
            <div [innerHTML]="message"></div>
          }
          @if (!isHtml) {
            {{ message }}
          }
        </div>
      } @else {
        <ng-content></ng-content>
      }
    </div>
    @if (closeable) {
      <button
        class="close-button"
        ds-button
        [variant]="DsButtonVariants.microAction"
        [microActionIcon]="Icons.XMark"
        [attr.aria-label]="'label_close' | translate"
        (click)="closeBanner()"
      ></button>
    }
  </div>
}
